// extracted by mini-css-extract-plugin
module.exports = {"noModalButtons":"DuplicateWorkspace_noModalButtons__RAeof"};